import { createContext, useContext, useState } from "react";

const AddContext = createContext();

export function useLocalContext() {
    return useContext(AddContext)
}

export function ContextProvider({children}) {
    const [createClassDialog, setCreateClassDialog] = useState(false)
    const [joinClassDialog, setJoinClassDialog] = useState(false)
    const [drawerSidebar, setDrawerSidebar] = useState(false)
    const [courseFormDialog, setCourseFormDialog] = useState(false)

    const value = { 
        createClassDialog, 
        setCreateClassDialog, 
        joinClassDialog, 
        setJoinClassDialog,
        drawerSidebar,
        setDrawerSidebar,
        courseFormDialog,
        setCourseFormDialog
    
    }
    return <AddContext.Provider value={value}>{children}</AddContext.Provider>
}